var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"pc",attrs:{"id":"wrapper"}},[_c('app-header'),_c('router-view',{ref:"mainPage"}),_c('app-footer'),_c('app-menu')],1),_c('div',{staticClass:"mobile",attrs:{"id":"wrapper"}},[_c('router-view',{ref:"mainPage"}),_c('app-Xmenu'),_c('div',[_c('app-XFooter')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }